module.exports = __webpack_public_path__ + "img/close.07c13abb.svg";